<template lang="pug">
.application-form
  form
    .form-item
      label.form-title お問い合わせ内容
        span.require 必須
      label.custom-radio(v-for='item in inquieryItems')
            | {{ item.label }}
            input(
              type='radio',
              v-model='inquieryType',
              name='radio',
              :value='item.value',
              @input="onChange"
            )
            span.checkmark
    .form-item
      label.form-title お名前
        span.require 必須
      text-field-small(
        required
        v-model="name"
        name="name"
        placeholder="例）田中 花子"
        @input="onChange"
      )
    .form-item
      label.form-title メールアドレス
        span.require 必須
      text-field-small(
        required
        v-model="email"
        type="email"
        placeholder="例）xxxxx@gmail.com"
        @input="onChange"
      )
    .form-item
      label.form-title 電話番号
        span.require 必須
      text-field-small(
        required
        v-model="tel"
        type="tel"
        placeholder="例）09012345678"
        @input="onChange"
      )
  </form>
</template>

<style lang="scss" scoped>
.application-form {
  form {
    padding: 32px 16px;
  }

  .form-item {
    margin-bottom: 24px;
    label.form-title {
      display: flex;
      margin-bottom: 8px;
      font-weight: 600;
      span.require {
        font-size: 12px;
        font-weight: 300;
        margin-left: 8px;
        padding: 2px 4px;
        background-color: rgba(255, 58, 76, 0.6);
        border-radius: 4px;
      }
    }
  }

  .custom-radio {
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 16px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    opacity: 0.9;
    font-family: 'Hiragino Sans';
    font-weight: 300;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.9);

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;

      &:checked ~ .checkmark {
        border: 1px solid #1faab3;

        &:after {
          display: block;
        }
      }
    }

    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 18px;
      width: 18px;
      background-color: #111d2b;
      border: 1px solid rgba(255, 255, 255, 0.4);
      border-radius: 50%;

      &:after {
        content: '';
        position: absolute;
        display: none;
        top: 4px;
        left: 4px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #1faab3;
      }
    }
  }
}
</style>

<script>
import TextFieldSmall from '@/components/molecules/TextFieldSmall'
import SubmittableForm from '@/components/mixins/SubmittableForm'

export default {
  components: {
    TextFieldSmall,
  },
  mixins: [SubmittableForm],
  props: {
    coachId: { type: String },
  },
  data() {
    return {
      name: '',
      email: '',
      tel: '',
      inquieryType: '無料体験レッスンの申し込み',
      inquieryItems: [
        {
          value: '無料体験レッスンの申し込み',
          label: '無料体験レッスンの申し込み',
        },
        { value: 'サービスに関する質問', label: 'サービスに関する質問' },
      ],
      googleAppsScriptUrl:
        'https://script.google.com/macros/s/AKfycbynwDHKtUQD6m4UNE7KB63D0ACkTAYun_GvNEZx41h2klURFoliAB8021_2JiHA9Rvkvw/exec',
    }
  },
  computed: {
    multilineText: function () {
      var result = this.error.message.split('\n').map((e) => this._i18n.t(e))
      return result.join('<br>')
    },
  },
  methods: {
    async submit() {
      this.error.message = ''
      return new Promise((resolve, reject) => {
        this.apply()
          .then(resolve)
          .catch((error) => {
            this.handleError(error)
            reject(error)
          })
      })
    },
    async apply() {
      await fetch(this.googleAppsScriptUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded', // フォームデータを送信するためのヘッダー
        },
        body: this.encodeFormData({
          'entry.1261828832': this.inquieryType,
          'entry.891635795': this.name,
          'entry.1569474369': this.email,
          'entry.117021277': this.tel,
          'entry.1229303855': 'アプリ',
        }),
      })
    },
    encodeFormData(data) {
      return Object.keys(data)
        .map(
          (key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
        )
        .join('&')
    },
    validate() {
      return (
        this.email.length > 0 && this.name.length > 0 && this.tel.length > 0
      )
    },
  },
}
</script>
